// ═══════════════════════════════════════════════════════════════════════════
// Two small helpers the record editors in file/modals.jsx still use. Everything else in Support
// Coordination (side panels, fields, buttons, formatters) comes from the SC kit (./kit).
// ═══════════════════════════════════════════════════════════════════════════

// A form's number field as a number: blank counts as 0.
export const num = (v) => (v === '' || v == null ? 0 : Number(v));
// Today as YYYY-MM-DD on this device's own clock.
export const isoToday = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; };
